module.exports = __webpack_public_path__ + "static/img/HR.78e961b2.png";